export const APP_DIR = 'reports'

export const ROUTE_KEY_BUY = 'buy'
export const ROUTE_KEY_HOME = 'home'
export const ROUTE_KEY_MARKETS = 'markets'

export const ROUTE_KEYS = [ROUTE_KEY_BUY, ROUTE_KEY_HOME] as const
export type RouteKeysType = typeof ROUTE_KEYS[number]
